import { mdmRegistryObj } from "../../features/mdm/mdmRegistry";
import { Action, mdmCardState } from "../../types"

const initialState:mdmRegistryObj = {
        id: "",
        name: "",
        entity: "",
        designation: "",
        menuOption: [],
        transformerInfo: [],
        tableHeaders:{},
        modalConfig:[],
        exportConfig:{},
        searchEnabledColumnsConfig:[],
        userNameKey:false, 
        disableEdit:false,
        getDataConfig: {
            api: "", 
            type: "", 
            searchKey: ""
        }
    }
export function mdmReducer(state:mdmRegistryObj=initialState,action:Action<mdmRegistryObj>):mdmRegistryObj{
    switch(action.type){
        case "setCurrentEntity":
            return {...action.payload}; 
    }
    return state
}
